"use client";

import * as React from "react";

import { MenuItem } from "@headlessui/react";
import { type VariantProps, cva } from "class-variance-authority";

import { cn } from "@/shared/helpers/cn.helper";

export interface DropdownItemProps extends React.ComponentProps<typeof MenuItem>, VariantProps<typeof variants> {}

const variants = cva("", {
  variants: {
    variant: {
      default: "cursor-pointer p-3 text-start text-sm hover:bg-gray-100",
      unstyled: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const DropdownItem = React.forwardRef<HTMLDivElement, DropdownItemProps>(({ variant, ...props }, ref) => {
  return (
    <MenuItem
      ref={ref}
      as="div"
      className={cn(variants({ variant }))}
      {...props}
    />
  );
});

DropdownItem.displayName = "DropdownItem";

export { DropdownItem };
